import { createUseStyles } from 'react-jss'
import { ThemeProps } from 'themes';

export const useStyles = createUseStyles(({ nextButton }: ThemeProps) => ({
    programWrapper: {
        background: '#FFFFFF',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        padding: '12px 16px',
        marginTop: '24px',
    },
    programTitle: {
        lineHeight: '24px',
        textAlign: 'left',
        margin: '12px 0'
    },
    medicationWrapper: {
        display: 'flex',
        flexDirection: 'column',
        padding: '24px 0 0',
        gap: '24px',
        borderTop: '1px solid #C5C5D1',

        '& img': {
            width: '100%',
            height: '168px',
            borderRadius: '8px',
            objectFit: 'cover',
            marginBottom: '24px'
        }
    },
    programItemBlock: {
        marginTop: '24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
    },
    programItem: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
    },
    circle: {
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        background: '#1375D6',
        color: '#FFFFFF',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'SF Pro Text',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 600,
        justifyContent: 'center',
        flexShrink: 0,
    },
    infoWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '8px',
        padding: '16px',
        background: '#E8F5FD',
        borderRadius: '8px',

        '& > p:first-child': {
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: 600,
        },

        '& > p': {
            fontSize: '14px',
            lineHeight: '18px',
        }
    },
    medicationOptions: {
        margin: '24px 0 12px 0',

        '& $programItem': {
            gap: '8px',
            alignItems: 'center',
            textAlign: 'left',
            marginBottom: '12px',

            '& img': {
                width: '16px'
            },

            '& p': {
                fontSize: '14px',
                lineHeight: '18px',
                fontWeight: 600,
            }
        }
    },
    priceBlock: {
        border: '1px solid #C5C5D1',
        borderRadius: '8px',
        padding: '8px',

        '& h1': {
            fontSize: '24px',
            textAlign: 'center',
            fontWeight: 400,
        }
    },
    nextButtonStyles: {
        ...nextButton.nextButton,
        margin: '24px 0 12px',

        '&:active': {
            ...nextButton.nextButtonHovered
        }
    },
    nextButtonClicked: {
        ...nextButton.nextButtonDisabled,
        background: '#CA5010'
    },
    '@media (min-width: 768px)': {
        programWrapper: {
            padding: '24px',
            marginTop: '32px',
        },
        programTitle: {
            margin: 'unset',
            fontSize: '34px',
            lineHeight: '44px',
            textAlign: 'left',
        },
        medicationWrapper: {
            borderTop: 'none',
            gap: '32px',
            padding: '24px 0 32px',
            borderBottom: '1px solid #C5C5D1',

            '& > div:first-child': {
                display: 'flex',
                flexDirection: 'row-reverse',
                gap: '40px',
            },

            '& img': {
                width: '272px',
                height: '194px',
                marginBottom: 0
            }
        },
        programItemBlock: {
            gap: '24px',
            marginTop: 'unset',
        },
        programItem: {

            '& p': {
                fontSize: '20px',
                lineHeight: '26px'
            }
        },
        medicationOptions: {
            margin: '32px 0',

            '& $programItem': {
                gap: '12px',
                alignItems: 'center',

                '& img': {
                    width: '28px'
                },

                '& p': {
                    fontSize: '20px',
                    lineHeight: '24px',
                    fontWeight: 600,
                },

                '&:last-child': {
                    marginBottom: 0,
                },
            }
        },
        priceBlock: {
            padding: '12px',
            marginBottom: '40px',

            '& h1': {
                fontSize: '30px',
                lineHeight: '32px',
            }
        },
        nextButtonStyles: {
            margin: 'unset',
            maxWidth: '375px'
        }
    }
}));
